import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Container, Progress} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as TextManager from "../../../modules/languages/TextManager";
import NumberFormat from 'react-number-format';
import Alert from "../../../components/Alert";
import * as http from "../../../modules/http";
import TextSearch from '../../../components/TextSearch';
import arrayToCsv from "../../../modules/arrayToCsv";


class ModalCheckLine extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            warning: '',
            errorText: '',
            phone: '',

            provider: '',
            valid: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }

    setNumber = (value) => {
        this.setState({phone: value.replace('-', '')})
    };

    send = () => {

        if (!this.state.phone || this.state.phone === '') {
            this.setState({warning: 'שדה מספר טלפון - חובה'});
            return;
        }        

        http.postToServer(
            'checkline/send?phone=' + this.state.phone + '&storeId=' + this.props.userData.data.id,
            {},
            (response) => {
                console.log(response.data);

                if(!response.data.result) {
                    this.setState({errorText: 'נוצרה תקלה בשרת נא לנסות מאוחר יותר'});
                }
                else {
                    this.setState({provider: response.data.current_carrier_name, valid: response.data.valid_number ? 'כן' : 'לא'});
                }
            },
            (response) => {
                console.log(response.data);
                this.setState({errorText: 'נוצרה תקלה בשרת נא לנסות מאוחר יותר'});
                //this.setState({errorText: response.data});
                //this.setState({errorText: response.data.message});
                //alert("שגיאה בשליחה");
            }
        );

    };

    handleDownload = () => {
        http.postToServer(
            'checkline/download',
            {},
            (response) => {
                //console.log(response.data);
                let data = response.data;

                if (data.length > 0) {
                    let csvContent = arrayToCsv({
                        data,
                        translated: {
                            ...TextManager.getCurrentTextResource().Customers,
                        },
                        excludeKey: []
                    });

                    let link = window.document.createElement("a");
                    link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
                    link.setAttribute("download", "download.csv");
                    link.click();
                }
            },
            (response) => {
                console.log(response.data);
            }
        );
    };

    toggle = () => {

        if(this.state.modal) {
            this.setState({modal: !this.state.modal, warning: '', errorText: '', phone: '', provider: '', valid: ''});
        }
        else {
            this.setState({
                modal: !this.state.modal
            });
        }
    };

    render() {

        let Icon;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            {this.state.errorText !== '' &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span> {this.state.errorText}
                                    </p>
                                </Alert>
                            </Row>}
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    <Row style={{flexDirection: "row-reverse"}}>

                                                        <Col md={4} xs={12}>
                                                            <label className="form__form-group-label"
                                                                   style={{fontWeight: 'bold', textAlign: 'center'}}>
                                                                נא לרשום את המספר מנוי המבוקש
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <NumberFormat name="customerName"
                                                                       style={{backgroundColor: '#F0F8FF'}}
                                                                       value={this.state.phone}
                                                                       type="text"
                                                                       dir={"auto"}
                                                                       onChange={(event) =>
                                                                           this.setNumber(event.target.value)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    {this.state.provider && <div className="progress-wrap progress-wrap--blue" style={{marginTop: '20px'}}>
                                                        <Progress value={100} />
                                                    </div>}

                                                    {this.state.provider && <Row style={{flexDirection: "row-reverse"}}>
                                                        <Col md={6} xs={12}>
                                                            <form className='form form--horizontal'>

                                                                <div className='form__form-group'>
                                                                    <label
                                                                        className='form__form-group-label'>חברת נוכחית:</label>
                                                                    <div className='form__form-group-field'>
                                                                        <TextSearch value={this.state.provider} disabled={true}/>
                                                                    </div>
                                                                </div>

                                                                <div className='form__form-group'>
                                                                    <label
                                                                        className='form__form-group-label'>האם המס פעיל:</label>
                                                                    <div className='form__form-group-field'>
                                                                        <TextSearch value={this.state.valid} disabled={true}/>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </Col>
                                                    </Row>}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Row>
                        <Col md={6} sm={12} lg={6} xs={12}>
                            {this.props.userData.data.isAdmin && <ButtonToolbar className='modal__footer' style={{paddingLeft: "20px", float: "left"}}>
                                <Button outline color='primary'
                                        onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>
                            </ButtonToolbar>}
                        </Col>
                        <Col md={6} sm={12} lg={6} xs={12}>
                            <ButtonToolbar className='modal__footer'>
                                <Button onClick={this.toggle}>{TextManager.getCurrentTextResource().Text.cancel}</Button>{' '}
                                <Button outline={this.props.colored} color={this.props.color}
                                        onClick={this.send}>
                                    {TextManager.getCurrentTextResource().Sales.salesItem.send}</Button>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalCheckLine))